import { render } from "./DetailsJourneyPage.vue?vue&type=template&id=3b69b15f&scoped=true"
import script from "./DetailsJourneyPage.vue?vue&type=script&lang=js"
export * from "./DetailsJourneyPage.vue?vue&type=script&lang=js"

import "./DetailsJourneyPage.vue?vue&type=style&index=0&id=3b69b15f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b69b15f"]])

export default __exports__